import { LocalStorageKey } from '@ddt-web/generic-utils';
import { UrlUtils } from '@ddt-web/url';

export class AuthUtil {

	public static isOktaEnabled(isCloudEnv: boolean = false): boolean {
		AuthUtil.checkOktaOverrideInUrl(isCloudEnv);

		return Boolean(localStorage.getItem(LocalStorageKey.UseOkta) === 'true' || window['BLK']?.isCloud || window['BLK']?.isAtmos);
	}

	/** 
	 * Checks if the user is logged in locally for pubic apps
	 * This is specific for MEx for now when user sign in from public view locally 
	 * @param request 
	 * @returns 
	 */
	public static isPublicAppLogin(): boolean {
		return UrlUtils.isLocalhost() && Boolean(sessionStorage.getItem(LocalStorageKey.PublicAppLogin) === 'true');
	}

	public static addInputsToForm(form: HTMLFormElement, inputs: { name: string; value: string }[]) {
		inputs.forEach(input => {
			const el = document.createElement('input');
			el.setAttribute('type', 'hidden');
			el.setAttribute('name', input.name);
			el.value = input.value;
			form.appendChild(el);
		});
	}

	private static checkOktaOverrideInUrl(isCloudEnv: boolean): void {
		// This is temporary - for testing purposes
		if (window.location.href.includes('okta=false') || (UrlUtils.isLocalhost() && !isCloudEnv)) {
			localStorage.removeItem(LocalStorageKey.UseOkta);
		} else if (UrlUtils.isLocalhost() && isCloudEnv || UrlUtils.isInternalHost()) {
			localStorage.setItem(LocalStorageKey.UseOkta, 'true');
		}
	}
}
